import { useEffect, useState } from "react";
import Custom from "../../../Components/Buttons/Custom";
import { useNavigate } from "react-router-dom";
import SVG from "../../../Components/SVG";
import GradientBlue from "../../../Components/InputFields/GradientBlue"
import { API_BASE_URL } from "../../../config/api";
import InfiniteScrollFooter from "../../../Components/InfiniteScrollFooter";
import usePaginatedAccounts from "../../../hooks/usePaginatedAccounts";

export default function DemoModal({ onClose, accountData, setModalClosed, demoPagination }) {
  const [createLoading, setCreateLoading] = useState(false);
  const [error, setError] = useState(null)
  const [step, setStep] = useState(1)
  const navigate = useNavigate();
  const accountPagination = usePaginatedAccounts({ navigate });
  const { initialLoading: accountInitialLoading, error: accountError, summary: accountsSummary, retry: retryAccounts, reload: reloadAccounts } = accountPagination;
  const hasAccountSummary = typeof accountsSummary?.has_demo_account === "boolean";
  const demoAccountExists = accountsSummary?.has_demo_account === true;
  const trainingOptions = [...(accountData || [])]
    .sort((a, b) => Number(a.initial_balance) - Number(b.initial_balance))
    .map((account) => ({
      id: account.id,
      title: account.name || `چالش ${Number(account.initial_balance || 0).toLocaleString()} دلاری`,
      description: account.description || "",
    }));
  const [selectedOption, setSelectedOption] = useState("");
  useEffect(() => {
    if (!selectedOption && trainingOptions[0]?.id) setSelectedOption(trainingOptions[0].id);
  }, [selectedOption, trainingOptions]);

  const handleOpen = async () => {
    setCreateLoading(true)
    setError(null)
    try {
      let response = await fetch(
        `${API_BASE_URL}challenges/trader/demo/${selectedOption}/create-account/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try to refresh
      if (response.status === 401) {
        try {
          const refreshResponse = await fetch(
            `${API_BASE_URL}auth/trader/jwt/refresh/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                refresh: localStorage.getItem("refresh"),
              }),
            },
          );

          if (!refreshResponse.ok) {
            // refresh failed → log out and redirect
            localStorage.removeItem("access");
            localStorage.removeItem("authCredentials");
            localStorage.removeItem("refresh");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            navigate("/signin");
            return; // ⬅️ IMPORTANT: stop here
          }

          const refreshData = await refreshResponse.json();
          localStorage.setItem("access", refreshData.access);

          // retry original request with new access token
          response = await fetch(
            `${API_BASE_URL}challenges/trader/demo/${selectedOption}/create-account/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("access")}`,
              },
            },
          );
          //need refresh without query params of the url
          window.location.replace(window.location.pathname);
        } catch (err) {
          setError("ایجاد چالش تمرینی با خطا مواجه شد،‌ مجدد تلاش کنید.")
          console.error("Error refreshing token:", err);
          setCreateLoading(false)
          return;
        }
      }

      // handle final response (original or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      // onClose();
      setCreateLoading(false)
      setStep(2)
    } catch (error) {
      setCreateLoading(false)
      setError("ایجاد چالش تمرینی با خطا مواجه شد،‌ مجدد تلاش کنید.")
      console.error("Error fetching account data:", error);
    }
  };
  if(step === 1){
  if (accountInitialLoading || demoPagination.initialLoading) {
    return (
      <div className="relative p-5 w-full max-w-2xl min-h-96 rounded-2xl flex flex-col gap-6 items-center justify-center bg-zi-bg2-light dark:bg-zi-bg2-dark drop-shadow-lg text-zi-text-light dark:text-zi-text-dark">
        در حال بارگذاری...
        <span onClick={onClose}>
            <SVG
              name="close"
              classname="absolute left-4 top-4 stroke-zi-text-light dark:stroke-zi-text-dark size-5 cursor-pointer"
            />
          </span>
      </div>
    );
  }

  if (accountError || !hasAccountSummary) {
    return (
      <div className="relative p-5 w-full max-w-2xl min-h-96 rounded-2xl flex flex-col gap-4 items-center justify-center bg-zi-bg2-light dark:bg-zi-bg2-dark drop-shadow-lg">
        <p className="text-sm text-red-500">بارگذاری حساب‌ها با خطا مواجه شد.</p>
        <button type="button" onClick={accountError ? retryAccounts : reloadAccounts} className="text-sm text-cyan-500">تلاش دوباره</button>
      </div>
    );
  }

  if (
    demoAccountExists
  ) {
    return (
      <div className="relative p-5 w-full max-w-2xl min-h-96 rounded-2xl flex flex-col gap-6 items-center justify-center bg-zi-bg2-light dark:bg-zi-bg2-dark drop-shadow-lg text-zi-text-light dark:text-zi-text-dark">
        همزمان حداکثر یک چالش تمرینی فعال می توان داشت
        <span onClick={onClose}>
            <SVG
              name="close"
              classname="absolute left-4 top-4 stroke-zi-text-light dark:stroke-zi-text-dark size-5 cursor-pointer"
            />
          </span>
      </div>
    );
  }
  return (
    <div className="p-5 w-full max-w-2xl h-fit rounded-2xl flex flex-col gap-6 bg-zi-bg2-light dark:bg-zi-bg2-dark drop-shadow-lg">
      <div className="w-full flex flex-col items-start gap-3">
        <div className="w-full flex items-start justify-between gap-3">
          <h5 className="font-medium text-base sm:text-xl text-zi-text-light dark:text-zi-text-dark overflow-hidden whitespace-nowrap text-ellipsis">
            ایجاد چالش تمرینی
          </h5>
          <span onClick={onClose}>
            <SVG
              name="close"
              classname="stroke-zi-text-light dark:stroke-zi-text-dark size-5 cursor-pointer"
            />
          </span>
        </div>
        <p className="font-normal text-sm sm:text-base text-zi-text-light/70 dark:text-zi-text-dark/70">
          چالش تمرینی مورد نظر خود را از بین گزینه‌های زیر انتخاب کنید:
        </p>
      </div>

      <div ref={demoPagination.scrollRootRef} className="flex max-h-64 flex-col gap-3 overflow-y-auto">
        {trainingOptions.map((option) => {
          const isSelected = option.id === selectedOption;
          return (
            <label
              key={option.id}
              className={`w-full flex items-center justify-between gap-4 rounded-2xl border px-4 py-3 cursor-pointer transition-colors ${
                isSelected
                  ? "border-zi-border-dark bg-zi-bg2-dark/5 dark:bg-zi-bg2-light/5"
                  : "border-zi-border-dark/50 hocus:border-zi-border-dark"
              }`}
            >
              <div className="flex items-center gap-3 text-right">
                <span
                  className={`size-4 rounded-full border-2 ${
                    isSelected
                      ? "border-zi-border-dark bg-zi-border-dark"
                      : "border-zi-border-dark"
                  }`}
                />
                <div>
                  <p className="text-sm sm:text-base font-medium text-zi-text-light dark:text-zi-text-dark">
                    {option.title}
                  </p>
                  <p className="text-xs text-zi-text-light/60 dark:text-zi-text-dark/60">
                    {option.description}
                  </p>
                </div>
              </div>
              <input
                type="radio"
                name="demoTrainingOption"
                value={option.id}
                checked={isSelected}
                onChange={() => setSelectedOption(option.id)}
                className="sr-only"
              />
            </label>
          );
        })}
        <InfiniteScrollFooter sentinelRef={demoPagination.sentinelRef} loading={demoPagination.loadingMore} error={demoPagination.error} onRetry={demoPagination.retry} hasNext={demoPagination.hasNext} compact />
        {!demoPagination.initialLoading && !demoPagination.error && trainingOptions.length === 0 && (
          <p className="py-3 text-center text-sm text-zi-text-light/60 dark:text-zi-text-dark/60">چالش تمرینی برای نمایش وجود ندارد</p>
        )}
      </div>

      <p className="font-light text-xs sm:text-base text-zi-text-light/70 dark:text-zi-text-dark/70">
        مهلت استفاده از چالش تمرینی ۵ روز است، در صورت پایان می‌توانید مجددا
        چالش تمرینی تهیه کنید.
      </p>

      {/* <div onClick={handleOpen}>
        <Custom
          text="ایجاد"
          className="bg-zi-gradient-button-blue mt-6 !text-base text-zi-text-dark w-full hocus:ring-1 hocus:ring-offset-1 hocus:ring-zi-border-dark"
        />
      </div> */}
      {!createLoading ? (
        <GradientBlue type="submit" value="ایجاد" onClick={handleOpen} disabled={!selectedOption} />
      ) : (
        <GradientBlue
          isLoader={true}
          type="submit"
          value="ایجاد"
          onClick={() => {}}
        />
        )}

        {
          error && <div className="text-red-500 text-sm font-light">{error}</div>
        }
    </div>
  );
}
if (step === 2) {
return (
      <div className="p-5 w-full max-w-2xl min-h-96 rounded-2xl flex flex-col gap-6 justify-between bg-zi-bg2-light dark:bg-zi-bg2-dark drop-shadow-lg">
        <div className="w-full flex flex-col items-start gap-3">
          <div className="w-full flex items-start justify-between gap-3">
            <h5 className="font-medium text-base sm:text-xl text-zi-text-light dark:text-zi-text-dark overflow-hidden whitespace-nowrap text-ellipsis">
              ایجاد چالش تمرینی
            </h5>
            <span onClick={onClose}>
              <SVG
                name="close"
                classname="stroke-zi-text-light dark:stroke-zi-text-dark size-5 cursor-pointer"
              />
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-4 items-center justify-center font-normal text-center text-sm sm:text-base text-zi-text-light/70 dark:text-zi-text-dark/70">
          <SVG name="check" classname="size-24 stroke-2 stroke-zi-text-light dark:stroke-zi-text-dark"/>
          <p className="text-zi-text-light dark:text-zi-text-dark">چالش تمرینی مورد نظر با موفقیت ایجاد گردید.</p>
        </div>

        
        <div className="flex flex-col gap-3">
          <p className="font-light text-sm sm:text-base text-zi-text-light/70 dark:text-zi-text-dark/70">
            جهت مشاهده چالش تمرینی خود برروی دکمه زیر بزنید.
          </p>
          <div onClick={() => {
            setModalClosed(true)
            onClose()
          }
          }>
            <Custom
              onClick={() => {
                setModalClosed(true)
                onClose()
              }
              }
              text="مشاهده لیست حساب‌ها و چالش‌ها"
              className="bg-zi-gradient-button-blue mt-0 !text-base text-zi-text-dark w-full hocus:ring-1 hocus:ring-offset-1 hocus:ring-zi-border-dark"
            />
          </div>
        </div>
      
    </div>
    );
  // if demo selected and created successfully
  }  

}
